import { encodeUrlQueryData, isNilOrEmpty } from './utils';

interface ImageOptimizationParams {
  worker?: string;
  prefix?: string;
  height?: number;
  width?: number;
  quality?: number;
  format?: 'auto' | string;
  opt?: boolean;
}

/**
 * Get the URL of the optimized image using EM image worker.
 * @see https://everymundo.atlassian.net/wiki/spaces/ProductManagement/pages/1952711082/airModules+-+Images+Management+via+Cloudflare+Service
 * @param imageUrl The original image
 * @param params Transformation parameters for the image
 * @returns
 */
export function getResizedImage(baseUrl: string, params: ImageOptimizationParams) {
  let imageUrl = baseUrl.replace(/[!'()*]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase();
  });

  if (isNilOrEmpty(params)) {
    return imageUrl;
  }
  const {
    worker = 'https://assets.airtrfx.com/cdn-cgi/image/',
    prefix = 'media-em/',
    ...queryArgs
  } = params;
  if (isNilOrEmpty(queryArgs) || !worker) {
    return imageUrl;
  }
  if (imageUrl.search(prefix) >= 0) {
    return `${imageUrl}?${encodeUrlQueryData(queryArgs)}`;
  }
  return `${worker}${encodeUrlQueryData(queryArgs, ',')}/${imageUrl}`;
}
